export default __webpack_public_path__ + "media/images/dashboard_icons/guestlist-dac3279f52c9d2394b6a29cea2818f05.svg";